// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bhj_a bhy_ea bhy_a","LoadingSwitch__init":"bhj_b bhy_a bhy_w bhy_j bhy_ul bhy_um bhy_fm"};